import {
  LetterbookSeriesType,
  LetterlistTableColumnSettingType,
} from "features/Letterbooks/types";
import LetterbookCell from "../LetterbookCell";
import BookSeriesPosition from "components/series/BookSeriesPosition";
import Text from "hardcover-ui/components/Text";

export default function SeriesPosition({
  letterbook,
}: {
  letterbook: LetterbookSeriesType;
}) {
  return (
    <LetterbookCell className="font-bold text-lg">
      <Text size="lg"><BookSeriesPosition bookSeries={letterbook.data.bookSeries} /></Text>
    </LetterbookCell>
  );
}

export const settings = {
  key: "SeriesPosition",
  title: "Series Position",
} as LetterlistTableColumnSettingType;
